/**
 * =====================================
 * UTILS
 * =====================================
 *
 * @package jessicariccardi_theme
 */

import interact from 'interactjs'
import jQueryBridget from 'jquery-bridget';
import ImageLoaded from 'imagesloaded';

jQueryBridget('imagesLoaded', ImageLoaded, $);
jQueryBridget('masonry', Masonry, $);


export default $(document).ready(function () {

  function dragMoveListener(event) {
    let target = event.target;
    // keep the dragged position in the data-x/data-y attributes
    let x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
    let y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

    // translate the element
    target.style.webkitTransform =
      target.style.transform =
        'translate(' + x + 'px, ' + y + 'px)';

    // update the posiion attributes
    target.setAttribute('data-x', x);
    target.setAttribute('data-y', y)
  }

  interact('.drag-drop')
    .draggable({
      inertia: true,
      autoScroll: true,
      // dragMoveListener from the dragging demo above
      onmove: dragMoveListener
    });

  let $grid = $('.jrtw-grid').imagesLoaded(
    function () {
      $grid.masonry({
        // set itemSelector so .grid-sizer is not used in layout
        itemSelector: '.jrtw-grid-item',
        // use element for option
        columnWidth: '.jrtw-grid-sizer',
        percentPosition: true,
      });
    }
  );
});
